import * as yup from 'yup';

import {
  MAX_FILTER_NAME_LENGTH,
  MIN_FILTER_NAME_LENGTH,
  NAME_EXCLUDED_SPECIAL_CHARS,
  NAME_EXCLUDED_SPECIAL_CHARS_WITH_DOT,
  NAME_SPECIAL_CHARS_V2,
  SPECIAL_CHARS_NOT_ALLOW_MESSAGE,
} from '../constants/validationConstants';
import { errorToast, warningToast } from './toastHelper';

export const createFilterNameSchema = ({ filterList, filter }) => {
  return yup
      .string()
      .min(MIN_FILTER_NAME_LENGTH, 'Filter name is required')
      .max(
        MAX_FILTER_NAME_LENGTH,
        `Filter name can not be longer than ${MAX_FILTER_NAME_LENGTH} characters`
      )
      .test('unique_name', 'Filter with this name already exist', (value) => {
        if (filter) {
          if (filter.label_name.toLowerCase() === value.toLowerCase()) return true;
        }

        return !filterList.find((f) => f.label_name.toLowerCase() === value.toLowerCase());
      })
      .required()
}


export const sanitizeName = (value, { maxLength, warningMessage = '' } = {}) => {
  if (!typeof value === 'string') value;

  value = value.replace(NAME_SPECIAL_CHARS_V2, '');

  if (value.length > maxLength) {
    value = value.substring(0, maxLength);
    if (warningMessage) warningToast(warningMessage);
  }

  return value;
};

export const isNameValid = (name, dotIncluded=false) => {

  if(typeof(name) !== 'string') return;
  
  const SPECIAL_CHARS = dotIncluded ? NAME_EXCLUDED_SPECIAL_CHARS_WITH_DOT: NAME_EXCLUDED_SPECIAL_CHARS;

  if(SPECIAL_CHARS.test(name)) {
    errorToast(SPECIAL_CHARS_NOT_ALLOW_MESSAGE + (dotIncluded ? "." : ''));
    return false
  }

  return true
}

export const createSimpleNameValidator = ({ 
  emptyError = 'Please provide name',
  nameTakenError = 'This name is already taken',
  nameKey = 'name',
  list,
  currentItem,
}) => (name) => {
  if (!name || name.trim() === '') return emptyError;

  const itemWithSameName = list.find(item => {
    if (item.id === currentItem?.id) return false;
    return item[nameKey].toLowerCase() === name.trim().toLowerCase();
  })

  if (itemWithSameName) return nameTakenError
}